export const UTILITY_MUTATIONS = Object.freeze({
    SET_UPTIME: "SET_UPTIME",
    UNSET_UPTIME: "UNSET_UPTIME",
    SET_VALUE: "SET_VALUE",
    SET_TEORIA_STATS: "SET_TEORIA_STATS",
    SET_TEORIA_PREFERITO: "SET_TEORIA_PREFERITO",
    SET_TEORIA_LETTURE: "SET_TEORIA_LETTURE",
    REMOVE_TEORIA_STATS: "REMOVE_TEORIA_STATS",
});
